/**
 * POST JSON with one automatic retry on transient 5xx / network errors.
 */
export async function postJsonWithRetry(url, { body, headers = {}, retries = 1 } = {}) {
  let lastError;
  let lastResponse;
  let lastData = {};

  for (let attempt = 0; attempt <= retries; attempt += 1) {
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...headers
        },
        body: JSON.stringify(body)
      });

      const data = await response.json().catch(() => ({}));
      lastResponse = response;
      lastData = data;

      if (response.ok || response.status < 500 || attempt === retries) {
        return { response, data };
      }

      // transient server error — retry
      await new Promise((resolve) => setTimeout(resolve, 400 * (attempt + 1)));
    } catch (error) {
      lastError = error;
      if (attempt === retries) {
        throw error;
      }
      await new Promise((resolve) => setTimeout(resolve, 400 * (attempt + 1)));
    }
  }

  if (lastResponse) {
    return { response: lastResponse, data: lastData };
  }
  throw lastError || new Error('Request failed');
}
